export default __webpack_public_path__ + "dfc64183dda2236453b213e08d27900b.svg";